import { fetcher } from "utils";

export const get__api__v1__stores__store_id__products = (storeId: string | number, params) =>
  fetcher.get(`/api/v1/stores/${storeId}/products`, params);
